import { CellDecorator } from '../Enum/TableDecorator';
import { Cell, HeaderCell, InterestTableDTO, Row } from '../Interface/Hook/Interest/InterestTableDTO';
import { Label } from '../Interface/Response/Interest/Label';
import { Company, PropertiesPerProperty } from '../Interface/Response/Interest/PropertiesPerProperty';
import { AcceptationGuideData } from '../Interface/Response/Interest/AcceptationGuideData';
import { PropertyAttributes } from '../Interface/Response/Interest/PropertyAttributes';

import { formatCamelCaseToHumanReadable } from '../Helpers/String';
import { findForLabel } from '../Helpers/Filter/AcceptationGuideHelper';
import { getLabel } from '../Helpers/LabelHelper';

const getCompany = (label: PropertiesPerProperty, companyFinDataCode: string): Company | undefined =>
    label.companies.find(({ finDataCode }) => finDataCode === companyFinDataCode);

const getUniqueFinDataCodes = (properties: PropertiesPerProperty[]): string[] => {
    const codes: string[] = [];
    properties.forEach(property => {
        property.companies.forEach(company => {
            codes.push(company.finDataCode);
        });
    });

    return codes.filter((value, index, self) => self.indexOf(value) === index);
};

const reduceTablePropertiesPerPropertyData = (
    properties: PropertiesPerProperty[],
    allLabels: Label[],
    acceptationGuideData: AcceptationGuideData[],
): InterestTableDTO => {
    const headers: HeaderCell[] = properties.map((property) => ({
        prop: property.code,
        value: formatCamelCaseToHumanReadable(property.name),
        sortable: true,
    }));

    headers.unshift({
        value: 'Product',
        prop: 'product',
        sortable: true,
        alwaysUseInPdf: true,
    });

    headers.unshift({
        value: '',
        prop: 'verstrekker',
        alwaysUseInPdf: true,
    });

    const data: Row[] = [];

    const finDataCodes = getUniqueFinDataCodes(properties);

    for (const uniqueFinDataCode of finDataCodes) {
        const cells = properties.reduce((acc: Cell[], curValue) => {
            const company = getCompany(curValue, uniqueFinDataCode);

            const cell = { value: company?.attributes, decorator: CellDecorator.ProductProperty };
            if (cell.value) {
                cell.value.label = getLabel(allLabels, company?.attributes.finDataCode);
                cell.value.property = {
                    category: curValue.code,
                    name: curValue.name,
                    attributes: company?.attributes as PropertyAttributes,
                };
            }
            return [...acc, cell];
        }, []);

        const currentLabel = getLabel(allLabels, uniqueFinDataCode);

        if (currentLabel === undefined) {
            continue;
        }

        const dataForLabel = findForLabel(acceptationGuideData, currentLabel);

        cells.unshift({
            value: {
                label: currentLabel.label,
                acceptationGuideData: dataForLabel,
            },
            decorator: CellDecorator.AcceptationGuide,
            alwaysUseInPdf: true,
        });

        cells.unshift({
            value: currentLabel.findataCode,
            decorator: CellDecorator.CompanyIcon,
            alwaysUseInPdf: true,
        });

        data.push({ cells });
    }

    return { data, headers };
};

export default reduceTablePropertiesPerPropertyData;
